export const REQUIRED = 'REQUIRED';
export const OPTIONAL = 'OPTIONAL';
export const DISABLED = 'DISABLED';

export const PROVIDER_SELECTION = [
  {
    key: REQUIRED,
    label: {
      id: 'General.Required',
      defaultMessage: '** Required',
    },
    hint: {
      id: 'Services.Create.ProviderSelectionField.RequiredOption.ToolTip',
      defaultMessage: '** A provider must be selected',
    },
  },
  {
    key: OPTIONAL,
    label: {
      id: 'General.Optional',
      defaultMessage: '** Optional',
    },
    hint: {
      id: 'Services.Create.ProviderSelectionField.OptionalOption.ToolTip',
      defaultMessage: '** Provider selection is optional',
    },
  },
  {
    key: DISABLED,
    label: {
      id: 'General.Disabled',
      defaultMessage: '** Disabled',
    },
    hint: {
      id: 'Services.Create.ProviderSelectionField.DisabledOption.ToolTip',
      defaultMessage: '** Provider cannot be selected',
    },
  },
];
